import { render } from "./StrategyManagement.vue?vue&type=template&id=71170b80"
import script from "./StrategyManagement.vue?vue&type=script&lang=js"
export * from "./StrategyManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__